import ConditionalSelectComponent from './conditional-select-component.js';

export const ConditionalSelectControl = wp.customize.KadenceControl.extend( {
	renderContent: function renderContent() {
		let control = this;
		ReactDOM.render( <ConditionalSelectComponent control={ control } customizer={ wp.customize } />, control.container[0] );
	}
} );
